import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { AllergenImages } from 'featureSliced/shared/utils/AllergenImages'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'

import {
  Allergen,
  AllergenItem,
  AllergensContainer,
  AllergensSections,
  AllergensTitle,
  AllergenText,
} from './styled'

type AllergensProps = {
  product: IProduct
}

export const Allergens: FC<AllergensProps> = ({ product }) => {
  const t = useTranslations()
  const { allergens: commonAllergens } = useMySelector((state) => state.common)

  return (
    <RenderIf condition={!!product?.allergens?.length}>
      <AllergensSections>
        <AllergensTitle>{t('filters.allergens')}</AllergensTitle>
        <AllergensContainer>
          {product?.allergens?.map((allergen, idx) => (
            <AllergenItem key={`product_allergen__${allergen.id}`}>
              <Allergen
                src={AllergenImages[allergen.id] || AllergenImages[0]}
                alt={String(allergen.id)}
              />
              <AllergenText>
                {product.allergenLabels?.[idx] ||
                  commonAllergens?.find((a) => a.id === allergen.id)?.name ||
                  allergen.label}
              </AllergenText>
            </AllergenItem>
          ))}
        </AllergensContainer>
      </AllergensSections>
    </RenderIf>
  )
}
